(ns ycweb.app.website.help.faqs
  (:require
   [rum.core :as rum]
   [ycweb.app.website.website :as website]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.help.common :as common]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.components.transitions :as t]
   [ycweb.components.toaster :as toaster]))

(rum/defc list-item-render < rum/reactive [app-atom {:article/keys [id url-name] :as article}]
  [:li
   [:a
    (merge
      (urlstate/href-props app-atom "help" "article" {:id id :name url-name})
      {:class (u/bem :text-link [:unmarked])})
    (:ent/display-name article)]])

(rum/defc list-render < rum/reactive [app-atom {:keys [total-articles articles url-name category-id]}]
  (into
    [:ul.yc-list]
    (cond
      (> total-articles 4)
      (concat
        [(map #(list-item-render app-atom %) (take 4 articles))
         [:li
          [:a.text-link
           (urlstate/href-props app-atom "help" "category" {:id category-id :name url-name})
           "View more..."]]])
      :else
      (map #(list-item-render app-atom %) articles))))

(rum/defc category-list-block < rum/reactive
  [app-atom
   {:help-category/keys [articles id url-name] :ent/keys [display-name]}]
  (let [total-articles (count articles)]
    (when (> total-articles 0)
      [:div
       {:class (u/bem :flex-grid-block [:ml-1-3 :s-1-2])}
       [:div.help-center-category.flex-grid-content
        (headings/heading
          [:a
           (merge
             {:class (u/bem :text-link [:muted])}
             (urlstate/href-props app-atom "help" "category" {:id id :name url-name}))
           display-name]
          {:type :h3 :size :small})
        [:div.help-center-category__content
         (list-render app-atom
           {:total-articles (count articles)
            :articles articles
            :category-id id
            :url-name url-name})]]])))

(rum/defc faqs < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        categories (cmn/curact process-atom :help-categories)]
    (web-common/set-meta-title! (str "Yuppiechef Help - FAQs"))
    [:div
     (common/help-center-banner app-atom {})
     (common/breadcrumbs app-atom {:faqs? true})
     [:div.yc-section
      [:div
       {:class (u/bem :yc-section [:standard])}
       (headings/heading "Frequently Asked Questions" {:type :h2 :size :medium :center true})]
      [:div
       {:class (u/bem :yc-section [:medium-underline])}
       [:div
        {:class (u/bem :flex-grid-group [:align-left :flush])}
        (map
          (fn [category]
            (category-list-block app-atom category))
          categories)]]
      [:div
       {:class (u/bem :yc-section [:large])}
       (common/help-center-footer app-atom)]
      (toaster/loading-overlay app-atom :web.help/list-faqs)]]))

(defmethod flow/render-screen :web.help/faqs [app-atom _]
  (website/screen-wrapper app-atom
    (faqs app-atom)
    {:pagetype :help
     :hidesearch true}))

(defmethod t/transition-open :web.help/faqs [app-atom _ _]
  (toaster/open-overlay app-atom :web.help/list-faqs)
  (comms/ajax-get :web.help/list-faqs {}))

(defmethod comms/receive :web.help/list-faqs [app-atom {:keys [help-categories] :as e}]
  (swap! (cmn/process-cursor app-atom) assoc
    :help-categories help-categories)
  (toaster/close-overlay app-atom :web.help/list-faqs))
